import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

export interface DialogData {
    error: 'nouser' | 'unexpected' | 'nolink' | 'fields' | 'noesb' | 'nodynamo';
}

@Component({
    selector: 'app-error-dialog',
    templateUrl: 'error.dialog.html',
    styleUrls: ['dialog.scss'],
})

export class ErrorDialogComponent {
    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData) {}
}
